import { render, staticRenderFns } from "./OneProductStocks.vue?vue&type=template&id=2a2f7ae0&scoped=true&"
import script from "./OneProductStocks.vue?vue&type=script&lang=ts&"
export * from "./OneProductStocks.vue?vue&type=script&lang=ts&"
import style0 from "./OneProductStocks.vue?vue&type=style&index=0&id=2a2f7ae0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_css-loader@4.3.0_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2f7ae0",
  null
  
)

export default component.exports